var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="avatar avatar--XL qa-user-avatar">\n  <div class="profilepicture">\n    ';
 if(isDefaultAvatar) { 
__p+='\n    <div class="default-avatar '+
((__t=( generatedAvatarClass ))==null?'':_.escape(__t))+
'">\n      '+
((__t=( avatarInital ))==null?'':_.escape(__t))+
'\n    </div>\n    ';
 }else{ 
__p+='\n    <img src="'+
((__t=( avatar ))==null?'':_.escape(__t))+
'" alt="'+
((__t=( name ))==null?'':_.escape(__t))+
'" />\n    ';
 } 
__p+='\n  </div>\n</div>\n';
}
return __p;
};
